import { createSelector } from 'reselect';

import { useGroupPlanName } from './NameContext';
import Select from '@/modules/AdminTools/components/Form/Select';
import { billingFrequenciesSelector } from '@/modules/AdminTools/redux/planBuilder/plans';

const toOptions = (arr) =>
  arr.map((billingFrequency) => ({
    label: billingFrequency,
    value: billingFrequency,
  }));

const billingFrequencyOptionSelector = createSelector(
  billingFrequenciesSelector,
  (state) => toOptions(state),
);

const BillingFrequencies = () => {
  const groupPlanName = useGroupPlanName();
  let name = 'billing_frequencies';
  if (groupPlanName) {
    name = `${groupPlanName}.${name}`;
  }

  return (
    <div className="mt-4 flex-grow">
      <Select
        isMulti
        required
        name={name}
        label="Billing Frequency"
        error="updatePlan"
        selector={billingFrequencyOptionSelector}
      />
    </div>
  );
};

export default BillingFrequencies;
